import React, { useEffect, useState } from "react";

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  const radius = 46;
  const circumference = 2 * Math.PI * radius;

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      const percent = (scrollTop / height) * 100;

      setProgress(percent);
      setVisible(scrollTop > 180);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const offset =
    circumference - (progress / 100) * circumference;

  return (
    <div
      className={`scroll-top style3 ${visible ? "show" : ""}`}
      onClick={() =>
        window.scrollTo({ top: 0, behavior: "smooth" })
      }
    >
      <svg viewBox="0 0 100 100">
        {/* background ring */}
        <circle
          cx="50"
          cy="50"
          r={radius}
          fill="none"
          stroke="#f1e6c8"
          strokeWidth="4"
        />

        {/* progress ring */}
        <circle
          cx="50"
          cy="50"
          r={radius}
          fill="none"
          stroke="#d4af37"
          strokeWidth="15"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{
            transition: "stroke-dashoffset 0.15s linear",
          }}
        />
      </svg>

      {/* <span className="arrow">↑</span> */}
    </div>
  );
};

export default ScrollToTop;

